import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {FunktionsbereichsauswahlPage} from './funktionsbereichsauswahl.page';
import {reducers} from './funktionsbereichsauswahl.reducer';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {VeranstaltungstypenVeranstaltungsTypFunktionsbereicheEffects} from '../../../client-ngrx/veranstaltungstypen';

const routes: Routes = [
    {
        path: '',
        component: FunktionsbereichsauswahlPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        SopiScrollModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('FunktionsbereichsauswahlModal', reducers),
        EffectsModule.forFeature([
            VeranstaltungstypenVeranstaltungsTypFunktionsbereicheEffects
        ]),
        SopiComponentsModule.forRoot()
    ],
    declarations: [FunktionsbereichsauswahlPage],
    entryComponents: [
        FunktionsbereichsauswahlPage
    ]
})
export class FunktionsbereichsauswahlPageModule {
    public static forRoot(): ModuleWithProviders<FunktionsbereichsauswahlPageModule> {
        return {
            ngModule: FunktionsbereichsauswahlPageModule,
            providers: []
        };
    }
}
